<template>
  <div class="news">
    <div
      class="news-head"
      :style="{
        background: `url(${$oss('trends/trends-bg.png')})`,
        backgroundSize: '100% 100%',
      }"
    >
      最新动态
    </div>
    <div class="news-data">
      <div>
        入驻实验室<span>{{ labTotal }}</span
        >家
      </div>
      <div>
        设备<span>{{ deviceTotal }}</span
        >个
      </div>
    </div>
    <div class="news-lists" v-loading="listLoading">
      <div v-for="(item, index) in news" :key="index" class="news-list">
        <div class="news-title flex flex-between">
          <span>更新了一个服务</span>
          <span class="news-device">{{ item.devicename }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mallList } from "@/api/mall";
import { labTotalNum, labDeviceTotal } from "@/api/lab";
export default {
  data() {
    return {
      listLoading: false,
      news: [],
      page: {
        pageIndex: 1,
        pageSize: 12,
      },
      labTotal: 0,
      deviceTotal: 0,
    };
  },
  created() {
    this.getNews();
    this.getLabTotal();
    this.getDeviceTatal();
  },
  methods: {
    async getNews() {
      this.listLoading = true;
      const { list } = await this.$axios
        .post(mallList, {
          ...this.page,
        })
        .finally(() => {
          this.listLoading = false;
        });
      this.news = list || [];
    },
    async getLabTotal() {
      const res = await this.$axios.post(labTotalNum, {
        laboratoryStatus: "1",
      });
      this.labTotal = res;
    },
    async getDeviceTatal() {
      const res = await this.$axios.get(labDeviceTotal);
      this.deviceTotal = res;
    },
  },
};
</script>
<style lang="scss" scoped>
.news {
  background: white;
  &-head {
    margin-bottom: 10px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    color: white;
    font-size: 16px;
  }
  &-data {
    color: #737373;
    padding: 6px 20px 4px 20px;
    span {
      color: #333333;
      margin: 0 4px;
    }
  }
  &-lists {
    min-height: 300px;
  }
  &-list {
    border-bottom: 1px solid #dde7ef;
    padding: 14px 20px;
    &:last-child {
      border-bottom: none;
    }
  }
  &-title {
    font-size: 15px;
    color: #1c1c1c;
    margin-bottom: 3px;
  }
  &-device {
    color: #4483ff;
    margin-left: 5px;
  }
}
</style>
